import { NO_HOST_FLAG } from '#components/patterns/entity-select/host/SelectHost.queries.ts';
import type { Route } from '#dn-types/route.ts';
import { ALL_ROLES_FLAG } from '#screens/routes/form/firewall-rule/CIDRFirewallRuleForm.queries.ts';
import type { RouteFormData } from '#screens/routes/form/route-form-schema.ts';

export function mapFormToRoute(formData: RouteFormData): Omit<Route, 'id' | 'createdAt' | 'modifiedAt'> {
  const routableCIDRs = formData.routableCIDRs.reduce<Route['routableCIDRs']>((accum, curr) => {
    accum[curr.cidr] = { install: curr.install };
    return accum;
  }, {});

  const routerHostID = formData.routerHostID === NO_HOST_FLAG ? null : formData.routerHostID;

  return {
    ...formData,
    routerHostID,
    routableCIDRs,
    firewallRules: mapFormDataToFirewallRules(formData.firewallRules),
  };
}

function mapFormDataToFirewallRules(formData: RouteFormData['firewallRules']): Route['firewallRules'] {
  return formData.map((rule) => ({
    localCIDR: rule.localCIDR,
    portRange: rule.portRange,
    description: rule.description,
    protocol: rule.protocol,
    allowedRoleID: rule.allowedRoleID === ALL_ROLES_FLAG ? null : rule.allowedRoleID,
    allowedTags: rule.tags,
  }));
}
